<template>
  <div class="about">
    <div class="about__wrap">
      <div class="pageTitle pageTitle--light">
        <h1>RENGAについて</h1>
        <div
          @click="backToTop"
          class="buttonMini buttonMini--circle38 backButton button--dark"
        >
          <img src="../assets/ui/back.png" width="8" height="14" alt="" />
        </div>
      </div>
    </div>

    <div class="about__wrap">
      <div class="about__desc">
        <img src="../assets/about/text1.png" alt="" />
      </div>

      <h2><img src="../assets/about/h2.png" alt="" /></h2>

      <section class="aboutStep aboutStep--1">
        <h3>
          <img src="../assets/about/step1.png" alt="STEP1" width="58.5" />
        </h3>
        <div class="aboutStep__fig">
          <img src="../assets/about/step1-img2.png" alt="" />
          <img class="arrow" src="../assets/about/arrow.png" alt="" />
          <img src="../assets/about/step1-img1.png" alt="" />
        </div>
        <div class="aboutStep__text">
          <img
            src="../assets/about/step1-text.png"
            alt="ENTERボタンを押してスタート！まずはメッセージを描く場所を決めよう。※投稿は１人１回です。描き直しは可能です。"
          />
        </div>
      </section>
      <section class="aboutStep aboutStep--2">
        <h3>
          <img src="../assets/about/step2.png" alt="STEP2" width="61" />
        </h3>
        <div class="aboutStep__fig">
          <img src="../assets/about/step2-img.png" alt="" />
        </div>
        <div class="aboutStep__text">
          <img src="../assets/about/step2-text.png" alt="" />
        </div>
      </section>
    </div>
    <section class="aboutStep aboutStep--3">
      <div class="about__wrap">
        <h3>
          <img src="../assets/about/step3.png" alt="STEP3" width="61" />
        </h3>
      </div>
      <div class="aboutStep__fig aboutStep__fig--3">
        <img src="../assets/about/step3-img.png" alt="" />
      </div>
      <div class="about__wrap">
        <div class="aboutStep__text">
          <img src="../assets/about/step3-text.png" alt="" />
        </div>
      </div>
    </section>
    <div class="about__wrap">
      <div class="about__location">
        <h3>
          <img src="../assets/about/location-text.png" alt="" />
        </h3>
        <figure>
          <img src="../assets/about/map.png" alt="" />
        </figure>
      </div>
    </div>
    <div class="about__wrap">
      <div class="about__screenImage">
        <h3>
          <img src="../assets/about/renga-image-text.png" alt="" />
        </h3>
        <figure class="about__screenImage1">
          <img src="../assets/about/wallimage.jpg" alt="" />
        </figure>
        <figure>
          <img src="../assets/about/wallimage2.jpg" alt="" />
        </figure>
      </div>
    </div>
    <div class="backToTop">
      <div class="button button--dark"><a @click="backToTop">TOPに戻る</a></div>
    </div>
    <div class="copyright">
      Copyright © PIA Corporation. All Rights Reserved.
    </div>
  </div>
</template>

<script>
import { setPage } from "../util/StoreUtil";

export default {
  name: "About",
  computed: {},
  methods: {
    backToTop() {
      setPage(null);
    }
  },
  mounted() {
    gtag("config", "UA-158811353-1", {
      page_title: "RENGAについて",
      page_path: "/about"
    });
  }
};
</script>

<style scoped lang="sass">
@import "../sass/common"
@import "../sass/zindex"
.about
  background: url("../assets/about/wall-bg.jpg") 0 0 repeat-y
  background-size: 375px 545px
  background-size: contain
.backButton
  img
    margin-left: -2px
.backToTop
  margin: 38px 0
  .button
    margin: auto
.about__wrap
  width: 87.2%
  margin: auto
  text-align: center

.about__desc
  @include bold
  @include vw(21)
  img
    width: 87.6106195%
  margin-bottom: 44px
h2
  line-height: 0
  margin-bottom: 20px
  img
    width: 49%
section

  h3
    background-color: #ffffff
    height: 22px
    @include flexVertical
    @include flexCenter
    margin-bottom: 20px
  .aboutStep__text
    margin-bottom: 37px
  .aboutStep__fig
    margin-bottom: 16.5px
    img
      display: block
.aboutStep--1
  .aboutStep__fig
    @include flexCenter
    justify-content: space-between
    img
      width: 44%
      &.arrow
        width: 4.1297935%
  .aboutStep__text img
    width: 88%

.aboutStep--2
  .aboutStep__fig
    img
      width: 96.460177%
      margin: auto
  .aboutStep__text img
    width: 85%
.aboutStep--3
  .aboutStep__fig
    margin-bottom: 0
    img
      width: 100%
      margin: auto
  .aboutStep__text img
    width: 94.6%
.about__location
  border-top: 1px dotted #ffffff
  padding-top: 42px
  margin-bottom: 42px
  h3
    margin-bottom: 18px
    img
      width: 70%
  figure
    img
      width: 100%
.about__screenImage
  border-top: 1px dotted #ffffff
  padding-top: 42px
  margin-bottom: 52px
  h3
    margin-bottom: 23px
    img
      width: 80%
  figure
    &.about__screenImage1
      margin-bottom: 18px
    img
      width: 100%
.backToTop .button
    height: 44px
    width: 9.6em
.copyright
  @include vw(10)
  text-align: center
  padding-bottom: 10px
</style>
